import React, { useContext, useEffect, useState } from "react";
import { NavLink, Navigate } from "react-router-dom";
import "../css/Navbar.css";
import { FaBars, FaTimes } from "react-icons/fa";
import { AuthContext } from "../pages/AuthContext";

export default function Navbar() {
  const { user, setUser, loading, setLoading } = useContext(AuthContext);
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState({});

  const path = window.location.pathname;

  let loginType = "/";
  if (path.includes("/tilmeld")) loginType = "academy";

  const DISCORD_LOGIN_URL = "https://linxlegacyacademy.dk/auth/discord/login";

  useEffect(() => {
    fetch("https://linxlegacyacademy.dk/auth/user", { credentials: "include" })
      .then((res) => res.json())
      .then((data) => {
        if (data.steam_id || data.discord_id) setUser(data);
        else setUser(null);
        setLoading(false);
      })
      .catch(() => {
        setUser(null);
        setLoading(false);
      });
  }, [setUser, setLoading]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 1300) setMenuOpen(false);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (loading) return null;
  if (path === "/turneringer") return null;

  if (!user && path.includes("/profil")) return <Navigate to="/login" />;

  const logout = async () => {
    await fetch("https://linxlegacyacademy.dk/auth/logout", { credentials: "include" });
    setUser(null);
    window.location.href = "/login";
  };

  // Kun navigation links — ingen profil/tilmeld her
  const navLinks = [
    { to: "/", label: "Forside" },
    { to: "/fornyemedlemmer", label: "For nye medlemmer" },
    { to: "/skolerogklubber", label: "Skoler & Klub" },
    { to: "/holdtider", label: "Holdtider" },
    { to: "/spil", label: "Spil vi tilbyder" },
    { to: "/omos", label: "Om os" },
    { to: "/åbningogpriser", label: "Åbningstider & Priser" },
  ];

  const renderLinks = (onClick) =>
    navLinks.map((link, idx) =>
      link.dropdown ? (
        <div key={idx} className="nav-item-with-dropdown">
          <button className="dropdown-toggle" onClick={() => setDropdownOpen((prev) => !prev)}>
            {link.label}
          </button>
          <div className={`dropdown-menu ${dropdownOpen ? "open" : ""}`}>
            {link.dropdown.map((d, i) => (
              <NavLink key={i} to={d.to} className={({ isActive }) => isActive ? "active" : ""} onClick={onClick}>
                {d.label}
              </NavLink>
            ))}
          </div>
        </div>
      ) : (
        <NavLink key={idx} to={link.to} className={({ isActive }) => isActive ? "nav-link active" : "nav-link"} onClick={onClick}>
          {link.label}
        </NavLink>
      )
    );

  const renderUserActions = (onClick) =>
    !user ? (
      <>
        <button className="discord-login" onClick={() => (window.location.href = `${DISCORD_LOGIN_URL}?type=${loginType}`)}>
          Login
        </button>
        <NavLink to="/tilmeld" className={({ isActive }) => isActive ? "register-link active" : "register-link"} onClick={onClick}>
          Bliv medlem
        </NavLink>
      </>
    ) : (
      <>
        <NavLink to="/profil" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"} onClick={onClick}>
          Profil
        </NavLink>
        <button onClick={logout} className="logout-btn">Log ud</button>
      </>
    );

  return (
    <nav className={`academy-navbar ${menuOpen ? "open" : ""}`}>

      {/* Logo */}
      <div className="nav-left">
        <NavLink to="/" className="nav-logo-wrap">
          <div className="logo-bg"></div>
          <img src="/favicon.ico" alt="Linx Logo" className="nav-logo" />
          <span className="nav-brand">Linx<br />Academy</span>
        </NavLink>
      </div>

      {/* Desktop Links */}
      <div className="nav-center">
        {renderLinks(null)}
      </div>

      {/* Desktop Right */}
      <div className="nav-right">
        {renderUserActions(null)}
      </div>

      {/* Burger */}
      <button className="burger" onClick={() => setMenuOpen((prev) => !prev)}>
        {menuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
      </button>

      {/* Mobile Menu */}
      <div className="mobile-menu">
        {renderLinks(() => setMenuOpen(false))}
        {renderUserActions(() => setMenuOpen(false))}
      </div>

    </nav>
  );
}